<template>
  <div class="newsletter-form" v-if="opened">
    <div class="newsletter-form__background" ref="background"></div>
    <div class="newsletter-form__form" ref="form">
      <lottie-animation
        path="assets/lottie/kreiselement.json"
        class="lottie"
        :loop="false"
        :autoPlay="false"
        :speed="1"
        @AnimControl="setCircleController"
      />

      <div class="newsletter-form__close" @click="onCloseClick">
        <svg
          width="19px"
          height="19px"
          viewBox="0 0 19 19"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="Page-2" stroke="none" stroke-width="1" stroke-linecap="square">
            <g
              id="Sign_up_pop_up"
              transform="translate(-1252.000000, -148.000000)"
              stroke-width="2"
            >
              <g id="Group-9" transform="translate(129.000000, 108.000000)">
                <g id="Group-4">
                  <g id="Group" transform="translate(1123.000000, 42.000000)">
                    <path
                      d="M0.956551136,0.947727607 L17.8715852,14.9103829"
                      id="Line"
                      transform="translate(9.414068, 7.929055) rotate(5.194429) translate(-9.414068, -7.929055) "
                    ></path>
                    <path
                      d="M17.8715852,0.947727607 L0.956551136,14.9103829"
                      id="Line-Copy"
                      transform="translate(9.414068, 7.929055) rotate(-185.194429) translate(-9.414068, -7.929055) "
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>

      <h1>{{ getText("newsletter_headline") }}</h1>

      <!--vue mailchimp test-->
      <!--<mailchimp-subscribe
        url="https://thinkmoto.us1.list-manage.com/subscribe/post-json"
        user-id="ab7168cea419c9ce1715420fd"
        list-id="eafef33fff"
        @error="onError"
        @success="onSuccess"
      >-->
      <mailchimp-subscribe
        url="https://thinkmoto.us1.list-manage.com/subscribe/post-json"
        user-id="a1acff002caedc55802f1e5b3"
        list-id="cf502ce49b"
        @error="onError"
        @success="onSuccess"
      >
        <template
          v-slot="{ subscribe, setEmail, setField, error, success, loading }"
        >
          <form ref="vue_form" @submit.prevent="subscribe">
            <label for="name">
              <span>{{ getText("newsletter_name") }}</span>
              <div class="row">
                <input
                  name="fullName"
                  id="fullName"
                  type="text"
                  @input="setField('fname', $event.target.value)"
                  :placeholder="getText('newsletter_name_placeholder')"
                />
              </div>
              
              <div class="row">
                <input
                  name="surName"
                  id="surName"
                  type="text"
                  @input="setField('lname', $event.target.value)"
                  :placeholder="getText('newsletter_surname_placeholder')"
                /></div>

              <!-- <span>{{ getText("newsletter_name") }}</span> -->
              
            </label>

            <label for="email">
              <span>{{ getText("newsletter_email") }}</span>
              <input
                name="email"
                id="email"
                type="email"
                @input="setEmail($event.target.value)"
                :placeholder="getText('newsletter_email_placeholder')"
              />
            </label>

            <button type="submit">
              {{ getText("newsletter_submit") }}
            </button>

            <div class="newsletter-form__error" v-if="error">
              <p v-html="error"></p>
              <!-- <p>{{ getText("mail_error") }}</p> -->
            </div>
            <div class="newsletter-form__success" v-if="success">
              <p>{{ getText("newsletter_success") }}</p>
            </div>
            <div v-if="loading"></div>
          </form>
        </template>
      </mailchimp-subscribe>
      <!--vue mailchimp test end-->
    </div>
    <div class="newsletter-form__hidden" ref="form_hidden">
      <div id="mc_embed_signup">
        <form
          action="https://thinkmoto.us1.list-manage.com/subscribe/post?u=a1acff002caedc55802f1e5b3&id=2655b107e3"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          class="validate"
          target="_blank"
          novalidate
        >
          <div id="mc_embed_signup_scroll">
            <h2>Subscribe</h2>
            <div class="indicates-required">
              <span class="asterisk">*</span> indicates required
            </div>
            <div class="mc-field-group">
              <label for="mce-EMAIL"
                >Email Address <span class="asterisk">*</span>
              </label>
              <input
                type="email"
                value=""
                name="EMAIL"
                class="required email"
                id="mce-EMAIL"
              />
            </div>
            <div class="mc-field-group">
              <label for="mce-FNAME">First Name </label>
              <input
                type="text"
                value=""
                name="FNAME"
                class=""
                id="mce-FNAME"
              />
            </div>
            <div class="mc-field-group">
              <label for="mce-LNAME">Last Name </label>
              <input
                type="text"
                value=""
                name="LNAME"
                class=""
                id="mce-LNAME"
              />
            </div>
            <div class="mc-field-group">
              <label for="mce-MMERGE6">Language </label>
              <select name="MMERGE6" class="" id="mce-MMERGE6">
                <option value=""></option>
                <option value="English">English</option>
                <option value="عربى">عربى</option>
              </select>
            </div>
            <div id="mce-responses" class="clear">
              <div
                class="response"
                id="mce-error-response"
                style="display: none"
              ></div>
              <div
                class="response"
                id="mce-success-response"
                style="display: none"
              ></div>
            </div>
            <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
            <div style="position: absolute; left: -5000px" aria-hidden="true">
              <input
                type="text"
                name="b_a1acff002caedc55802f1e5b3_2655b107e3"
                tabindex="-1"
                value=""
              />
            </div>
            <div class="clear">
              <input
                type="submit"
                value="Subscribe"
                name="subscribe"
                id="mc-embedded-subscribe"
                class="button"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import MailchimpSubscribe from "@/plugins/mailchimp/mailchimp";
import ContentMixin from "@/mixins/ContentMixin";
export default {
  name: "NewsletterForm",
  mixins: [ContentMixin],
  components: {
    MailchimpSubscribe,
  },
  data() {
    return {
      endpoint:
        "https://thinkmoto.us1.list-manage.com/subscribe/post?u=ab7168cea419c9ce1715420fd&id=eafef33fff",
    };
  },
  computed: {
    opened() {
      return this.$store.getters.newsletter;
    },
  },
  watch: {
    opened() {
      if (this.opened) {
        gsap.set("body, html", {
          overflow: "hidden",
        });

        this.$nextTick(() => {
          gsap.from(this.$refs.background, {
            duration: 0.5,
            autoAlpha: 0,
          });

          gsap.from(this.$refs.form, {
            transformOrigin: "center center",
            delay: 0.1,
            duration: 0.3,
            y: 50,
            autoAlpha: 0,
          });
        });
      } else {
        gsap.set("body, html", { overflow: "" });
      }
    },
  },
  methods: {
    onError(e) {
      e;
      // handle error
      // console.log("ERROR", e);
    },
    onSuccess(success) {
      success;
      // handle success
      // console.log("SUCCESS!", success);
    },

    setCircleController(el) {
      el.play();
      gsap.from(this.$el.getElementsByClassName("lottie"), {
        duration: 1,
        delay: 0.5,
        alpha: 0,
      });
    },
    onSubmitClick() {
      //const form = this.$refs.form_hidden.getElementsByTagName("form");
      const form = this.$refs.vue_form;
      console.log(form);
      //form.submit();
    },
    copyTextField(e) {
      const inputs = Array.from(
        this.$refs.form_hidden.getElementsByTagName("input")
      ).filter((item) => item.classList.contains(e.target.name));

      if (inputs[0]) {
        inputs[0].value = e.target.value;
      }
    },
    onCloseClick() {
      gsap
        .to(this.$refs.background, {
          delay: 0.2,
          duration: 0.5,
          autoAlpha: 0,
        })
        .then(() => {
          this.$store.commit("set_newsletter", false);
        });
      gsap.to(this.$refs.form, {
        transformOrigin: "center center",
        duration: 0.3,
        autoAlpha: 0,
      });
    },
  },
  mounted() {
    /*axios
.get('https://api.coindesk.com/v1/bpi/currentprice.json') .then(response =>
(this.info = response.data.bpi)) .catch(error => console.log(error)) }*/
  },
};
</script>
